import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomButtonComponent } from "../../../../shared/components/custom-button/custom-button.component";
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-green-mobility-card',
  standalone: true,
  imports: [CustomButtonComponent, TranslocoPipe],
  templateUrl: './green-mobility-card.component.html',
  styleUrl: './green-mobility-card.component.css'
})
export class GreenMobilityCardComponent {
  @Input() imageSrc: string = '';
  @Input() iconSrc: string = '';
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() buttonText: string = '';
  @Output() buttonClick = new EventEmitter<void>();

  onClick() {
    this.buttonClick.emit();
  }
}
